import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const MentorCard = ({ mentor, onConnect }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Available': return 'text-success bg-success';
      case 'Busy': return 'text-warning bg-warning';
      case 'Offline': return 'text-muted-foreground bg-muted-foreground';
      default: return 'text-muted-foreground bg-muted-foreground';
    }
  };

  return (
    <div className="holographic-card group">
      <div className="p-6">
        {/* Mentor Header */}
        <div className="flex items-start space-x-4 mb-4">
          <div className="relative">
            <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-accent/30">
              <Image
                src={mentor.avatar}
                alt={mentor.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className={`absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-card ${getStatusColor(mentor.status)}`}></div>
          </div>
          
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-1">{mentor.name}</h3>
            <p className="text-sm text-accent mb-1">{mentor.title}</p>
            <p className="text-sm text-muted-foreground">{mentor.company}</p>
          </div>

          <div className="flex items-center space-x-1 text-warning">
            <Icon name="Star" size={14} fill="currentColor" />
            <span className="text-sm font-medium">{mentor.rating}</span>
          </div>
        </div>

        {/* Expertise */}
        <div className="mb-4">
          <h4 className="text-sm font-medium text-foreground mb-2">Expertise</h4>
          <div className="flex flex-wrap gap-2">
            {mentor.expertise.map((skill, index) => (
              <span 
                key={index}
                className="px-2 py-1 bg-accent/10 text-accent text-xs rounded-md border border-accent/20"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 mb-4 py-3 border-t border-b border-border/50">
          <div className="text-center">
            <div className="text-lg font-bold text-foreground">{mentor.experience}</div>
            <div className="text-xs text-muted-foreground">Years Exp</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-bold text-foreground">{mentor.mentees}</div>
            <div className="text-xs text-muted-foreground">Mentees</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-bold text-foreground">{mentor.sessions}</div>
            <div className="text-xs text-muted-foreground">Sessions</div>
          </div>
        </div>

        {/* Bio */}
        <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
          {mentor.bio}
        </p>

        {/* Availability */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <Icon name="Clock" size={14} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">Next available:</span>
          </div>
          <span className="text-sm font-medium text-foreground">{mentor.nextAvailable}</span>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="MessageCircle"
            iconPosition="left"
            className="flex-1"
          >
            Message
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="Calendar"
            iconPosition="left"
            onClick={() => onConnect(mentor)}
            className="flex-1 morphing-cta"
          >
            Book Session
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MentorCard;